import React, { useState, useRef, useCallback } from 'react';
import ReactDom from 'react-dom';
import Cropper from 'react-easy-crop';
import Slider from '@mui/material/Slider';
import IconButton from '@mui/material/IconButton';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import getCroppedImg from './CropImage';
import './CropPhotoModal.css';

export const CropPhotoModal = ({ imageSrc, setImageSrc, setShowModal, onCropComplete, aspect = 1.618, cropShape = 'rect', maxSize, quality }) => {
  const modalRef = useRef();
  // const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const closeModal = (e) => {
    if (e.target === modalRef.current) {
      setShowModal(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
      };
    }
  };

  const onCropCompleteHandler = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = async () => {
    try {
      const options = {};
      if (maxSize !== undefined) options.maxSize = maxSize;
      if (quality !== undefined) options.quality = quality;
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, options);
      onCropComplete(croppedImage);
      setShowModal(false);
    } catch (error) {
      console.error("Error cropping image:", error);
    }
  };

  const handleZoomChange = (event, newValue) => {
    setZoom(newValue);
  };

  return ReactDom.createPortal(
    <div className="modal-container" ref={modalRef} onClick={closeModal}>
      <div className="modal-content">
        {!imageSrc ? (
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        ) : (
          <>
            <div className="cropper-container">
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                cropShape={cropShape}
                showGrid={cropShape !== 'round'}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropCompleteHandler}
              />
            </div>
            <div className="crop-actions">
              <IconButton onClick={() => setZoom(Math.max(zoom - 0.1, 1))}>
                <ZoomOutIcon />
              </IconButton>
              <Slider
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={handleZoomChange}
                aria-labelledby="continuous-slider"
                sx={{ width: 200 }}
              />
              <IconButton onClick={() => setZoom(Math.min(zoom + 0.1, 3))}>
                <ZoomInIcon />
              </IconButton>
              <button onClick={handleSave} className="submit-button">Submit</button>
            </div>
          </>
        )}
        <button className="close-modal-button" onClick={() => setShowModal(false)}>X</button>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default CropPhotoModal;

